<template>
  <div id="chargebackAlerts">
    <header-nav :content="$t('pages_router_061')" />
    <div class="rdr-balance">{{ $t('pages_receipt_092') }} {{ balanceInfo }}</div>
    <div class="common-card-body">
      <a-tabs
        v-model:activeKey="labName"
        class="order-tabs"
      >
        <a-tab-pane key="ethocaRecords" :tab="$t('pages_receipt_053')">
          <ethoca-records
            ref="ethocaRecordsRef"
          />
        </a-tab-pane>
        <a-tab-pane key="rdrRecords" :tab="$t('pages_receipt_054')">
          <rdr-records
            ref="rdrRecordsRef"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import HeaderNav from '@/components/header-nav'
import EthocaRecords from './components/ethoca-records'
import RdrRecords from './components/rdr-records'
import { parseMoney } from '@/util'
import { _order } from '@/api'
import { ref, reactive, toRefs } from 'vue'
export default {
  name: 'ChargebackAlerts',
  components: {
    'ethoca-records': EthocaRecords,
    'rdr-records': RdrRecords,
    'header-nav': HeaderNav
  },
  setup() {
    const ethocaRecordsRef = ref(null)
    const rdrRecordsRef = ref(null)

    const state = reactive({
      balanceInfo: '0.00 USD'
    })

    const loadRdrBalance = async () => {
      const { data } = await _order.getMerchantRdrInfo()
      if (data && data.data) {
        const { rdrBalance, rdrCurtype } = data.data
        if (rdrBalance != null && rdrCurtype != null) {
          state.balanceInfo = `${parseMoney(rdrBalance)} ${rdrCurtype}`
        }
      }
    }

    loadRdrBalance()

    return {
      ethocaRecordsRef,
      rdrRecordsRef,
      loadRdrBalance,
      ...toRefs(state)
    }
  }
}
</script>

<style lang="less" scoped>
#chargebackAlerts {
  .common-card-body {
    .order-tabs {
      padding: 0 24px;
    }
  }
  .rdr-balance {
    font-size: 14px;
    font-weight: 500;
    color: #797ff1;
    // round rect background
    background: #FFF;
    border-radius: 4px;
    padding: 10px;
    margin-top: 10px;
  }
}
</style>
